module.exports = __webpack_public_path__ + "img/video-placeholder.bfe15161.svg";